export default __webpack_public_path__ + "static/media/Memo Shortcut.4638ffb0.png";